const dummyData = [
    {
        id: 281,
        question: "The IUPAC nomencalatyre of the compound LiAIH4 is",
        option: {
            "a": "Aluminium tetrahydrido lithium",
            "b": "Tetrahydrido lithium aluminate (III)",
            "c": "Lithium aluminium hydride",
            "d": "Lithium tetrahydridoaluminate (III)"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 283,
        question: "What quantity of aluminum is deposited when a current of 10A is passed through a solution of an aluminum salt for 1930s  {AI = 27, F = 96500 C mol-}",
        option: {
            "a": "1.8g",
            "b": "5.4g",
            "c": "14.2g",
            "d": "0.2g"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 267,
        question: "The stability of the noble gases is due to the fact that they",
        option: {
            "a": "Have duplet or octet electron configurations",
            "b": "Belong to group zero of the periodic table",
            "c": "Are volatile in nature",
            "d": "Have no electron in their outermost shells"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 294,
        question: "The residual solids from the fractional distillation of petroleum are used as",
        option: {
            "a": "Raw materials for the cracking process",
            "b": "Fuel for driving tractors",
            "c": "Fuel for jet engines",
            "d": "Coatings for pipes"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 291,
        question: "When iron is exposed to moist air, it gradually rusts. This is due to the formation of",
        option: {
            "a": "Anahydrous  iron (III) oxide",
            "b": "Anhydrous iron (II) oxide",
            "c": "Hydrated iron (II) oxide",
            "d": "Hydrated iron  (III) oxide"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 302,
        question: "The haloalkanes used in the dry cleaning industries are",
        option: {
            "a": "Chloroethane and dichloroethene",
            "b": "trichloroethene and tetrachloroethene",
            "c": "chloromethane and dichloroethene",
            "d": "Trichloromethane and tetrachloromethane"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 266,
        question: "How many unpaired electron(s) are there in the nitrogen  sub - levels",
        option: {
            "a": "2",
            "b": "1",
            "c": "0",
            "d": "3"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 295,
        question: "Which of the following is used as fuel in miners’ lamp",
        option: {
            "a": "Ethyne",
            "b": "Ethane",
            "c": "Ethane",
            "d": "Ethanol"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 262,
        question: "Calculate the percentage by mass of nitrogen in calcium trioxonitrate (V)   {Ca = 40, N = 14, O = 16}",
        option: {
            "a": "13.10%",
            "b": "17.10%",
            "c": "27.60%",
            "d": "8.5"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 271,
        question: "Permanent hardness of water can be removed by",
        option: {
            "a": "Adding slaked lime",
            "b": "Adding caustic soda",
            "c": "Boiling",
            "d": "Filtration"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 265,
        question: "Moving from left to right across a period, the general rise in the first ionization energy can be attributed to the",
        option: {
            "a": "Increase in nuclear charge",
            "b": "Decrease in screening effect",
            "c": "Increase in screening effect",
            "d": "Decrease in nuclear charge"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 292,
        question: "A compound gives an orange red colour to a non luminous flame. This compound is likely to contain",
        option: {
            "a": "Ca2+",
            "b": "Fe3+",
            "c": "Fe2+",
            "d": "Na+"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 269,
        question: "Elements in the same periodic table have the same",
        option: {
            "a": "Atomic number",
            "b": "Chemical properties",
            "c": "Physical properties",
            "d": "Number of shells"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 300,
        question: "The correct order of increasing boiling points of the following  compounds C3H7OH, C7H16 and C4H10 is",
        option: {
            "a": "C4H10  →  C7H16 → C3H7OH",
            "b": "C7H16 → C3H7OH → C4H16",
            "c": "C4H10  → C3H7OH  → C4H10",
            "d": "C3H7OH →  C4H10  → C7H16"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 285,
        question: "If a reaction is exothermic and thee is a great disorder, it means that",
        option: {
            "a": "The reaction is in a state of equilibrium",
            "b": "There will be a large increase in free energy",
            "c": "There will be a large decrease in free energy",
            "d": "The reaction is static"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 278,
        question: "The colour of methyl orange in alkaline medium is",
        option: {
            "a": "Pink",
            "b": "Orange",
            "c": "Red",
            "d": "Yellow"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 270,
        question: "A noble gas with a high power of fog penetration used in aerodrome beacons is",
        option: {
            "a": "Argon",
            "b": "Helium",
            "c": "Neon",
            "d": "Krypton"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 261,
        question: "Which of the following is an example of a mixture",
        option: {
            "a": "Blood",
            "b": "Sand",
            "c": "Washing soda",
            "d": "Common salt"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 296,
        question: "Which of the following organic compounds is very soluble in water",
        option: {
            "a": "C2H2",
            "b": "C2H4",
            "c": "CH3COOC2H5",
            "d": "CH3COOH"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 280,
        question: "6AgNO3(aq)  +  PH3(g) +    3H2O(l)      →    6Ag(s)+   H3PO3(aq)   +    6HNO3(aq)  In the reaction above, the reducing agent is",
        option: {
            "a": "H2O(l)",
            "b": "PH3(g)",
            "c": "AgNO3(aq)",
            "d": "HNO3(AQ)"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 274,
        question: "Coffee stains can best be removed by",
        option: {
            "a": "Turpentine",
            "b": "A solution of borax in water",
            "c": "Ammonia solution",
            "d": "Kerosene"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 275,
        question: "Carbon (II) oxide is considered dangerous if inhaled mainly because it",
        option: {
            "a": "Competes with oxygen in the blood",
            "b": "Competes with carbon (IV) oxide in the blood",
            "c": "Can cause lung cancer",
            "d": "Can cause injury to the nervous system"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 303,
        question: " Two hydrocarbons X and Y were treated with bromine water. Decolorized the solution and Y did not. Which class of compound does Y belong",
        option: {
            "a": "Alkynes",
            "b": "Alkenes",
            "c": "Alkanes",
            "d": "Benzene"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 263,
        question: "The droplets of water observed around a bottle of milk taken out of though refrigerator is due to the fact that the",
        option: {
            "a": "Temperature of the milk drops as it loses heat into the surroundings",
            "b": "Saturated vapour pressure of the milk is equal to the atmospheric pressure",
            "c": "Water vapour in the air around loses some of its energy to the bottle",
            "d": "Water vapour in the air around the bottle gains some energy from the bottle"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 289,
        question: "Which of the following is used as a rocket fuel",
        option: {
            "a": "CH3COOH",
            "b": "H2SO4",
            "c": "HCL",
            "d": "HNO3"
        },
        section: "",
        image: "",
        answer: "d",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 286,
        question: "In the preparation of oxygen by heating KCIO3 in the presence of MnC2, only moderate hear is needed because the catalyst acts by",
        option: {
            "a": "Increasing the surface area of the reactant",
            "b": "Increasing the rate of the reaction",
            "c": "Lowering the energy barrier of the reaction",
            "d": "Lowering the pressure of the reaction"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 297,
        question: "Benzene reacts with hydrogen in the presence of nickel catalyst at 1800C to give",
        option: {
            "a": "Toluene",
            "b": "Cyclopentane",
            "c": "Cyclohexane",
            "d": "Xylene"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 272,
        question: "Substances employed as drying agents are usually",
        option: {
            "a": "Hygroscopic",
            "b": "Efflorescent",
            "c": "Acidic",
            "d": "Amphoteric"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 279,
        question: "Which of the following salts is slightly soluble in water",
        option: {
            "a": "CaSO4",
            "b": "Na2CO3",
            "c": "PbCl2",
            "d": "AgCl"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 284,
        question: "In which of the following is the entropy change positive",
        option: {
            "a": "Reaction between an acid and a base",
            "b": "Addition of concentrated acid to water",
            "c": "Dissolution of sodium metal in water",
            "d": "Thermal dissociation of ammonium chloride"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 287,
        question: "2H2(g) +    O2(g)  ⇌ 2H2O(g)    ΔH   =  - ve  What happens to the equilibrium constant of the reaction above if the temperature is increased?",
        option: {
            "a": "It becomes zero",
            "b": "It decreases",
            "c": "It increases",
            "d": "It is unaffected"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 290,
        question: "A constituent common to moist air, it gradually rusts. This is due to the formation of",
        option: {
            "a": "Silver",
            "b": "Copper",
            "c": "Tin",
            "d": "Lead"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 293,
        question: "Stainless steel is used for making",
        option: {
            "a": "Tools",
            "b": "Coins and medals",
            "c": "Moving parts of clocks",
            "d": "Magnets"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 282,
        question: "Iron can be protected from corrosion by coating the surface with",
        option: {
            "a": "Silver",
            "b": "Copper",
            "c": "Zinc",
            "d": "Gold"
        },
        section: "",
        image: "",
        answer: "c",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 299,
        question: "The final products of the reaction between methane and chloride in the presence of ultraviolet light are hydrogen chloride and",
        option: {
            "a": "Dichloromethane",
            "b": "Tetrachloromethane",
            "c": "Chloromethane",
            "d": "Trichloromethane"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 276,
        question: "The acid that is used to remove rust is",
        option: {
            "a": "Hydrochloric",
            "b": "Trioxonitrate (V)",
            "c": "Tetraoxosulphate (VI)",
            "d": "Boric"
        },
        section: "",
        image: "",
        answer: "b",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 304,
        question: "The compound that is used as an anaesthetic is",
        option: {
            "a": "CHCI3",
            "b": "CH2C2",
            "c": "CH3CI",
            "d": "CCI4"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 268,
        question: "The maximum number of electrons in the L shell of an atom is",
        option: {
            "a": "8",
            "b": "18",
            "c": "32",
            "d": "2"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 273,
        question: "Calculate the solubility in mol dm -3 of 40g of Cu So4 dissolved in 100g of water at 1200C  {Cu = 64, S = 32, 0 = 16}",
        option: {
            "a": "2.5",
            "b": "0.4",
            "c": "0.25",
            "d": "4"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    },
    {
        id: 264,
        question: "The volume of a gas is Vcm3 at P mm Hg. What is the new volume of the gas if the pressure is reduced to half at constant temperature",
        option: {
            "a": "2 V cm3",
            "b": "V  2cm3",
            "c": "V cm3",
            "d": "4 V cm3"
        },
        section: "",
        image: "",
        answer: "a",
        solution: "",
        examtype: "utme",
        examyear: "2010"
    }
]

export default dummyData